module.exports = __webpack_public_path__ + "static/media/[Art_and_Music]2010-07-18-1.83bea369.md";